module.exports = __webpack_public_path__ + "img/text-to-speech.b2226f16.png";